import type { AddPaymentInfoData } from '@/events/conversion';

import { BaseTracker } from './BaseTracker';
import type { TrackerFactory } from './TrackerFactory';

export class AddPaymentInfoTracker extends BaseTracker {
  constructor(factory: TrackerFactory) {
    super(factory);
  }

  track(data?: AddPaymentInfoData): void {
    if (!this.factory.isManualEnabled('addPaymentInfo')) return;
    this.factory.dispatchManual('ADD_PAYMENT_INFO', data);
  }
}
